import { render, staticRenderFns } from "./PrivacyPolicyModal.vue?vue&type=template&id=b5bb73b4&scoped=true&"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=b5bb73b4&scoped=true&lang=scss&"
import style1 from "./PrivacyPolicyModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bb73b4",
  null
  
)

export default component.exports